/* ============================================================
   SMILE+ — Landing page interactions
   Skapad av Claude Code
   Stjärnor, dragspel, paketval, sticky-element + Lägg-i-varukorg
   via /cart/add.js (samma mönster som svd-productblock-variant-selector).
   ============================================================ */
(function () {
  "use strict";

  /* ---------- star ratings ---------- */
  function starSvg(fill) {
    var id = "smlg" + Math.random().toString(36).slice(2, 8);
    var d = "M12 2.6l2.7 5.9 6.3.6-4.8 4.2 1.5 6.2L12 16.9 6.3 19.5l1.5-6.2L3 9.1l6.3-.6z";
    if (fill === 1) return '<svg viewBox="0 0 24 24" fill="currentColor"><path d="' + d + '"/></svg>';
    if (fill === 0) return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4"><path d="' + d + '"/></svg>';
    return '<svg viewBox="0 0 24 24"><defs><linearGradient id="' + id + '"><stop offset="50%" stop-color="currentColor"/><stop offset="50%" stop-color="currentColor" stop-opacity="0"/></linearGradient></defs><path fill="url(#' + id + ')" stroke="currentColor" stroke-width="1.2" d="' + d + '"/></svg>';
  }

  function renderStars(root) {
    root.querySelectorAll(".stars").forEach(function (el) {
      var rating = parseFloat(el.getAttribute("data-stars") || "5");
      var html = "";
      for (var i = 1; i <= 5; i++) {
        if (rating >= i) html += starSvg(1);
        else if (rating >= i - 0.5) html += starSvg(0.5);
        else html += starSvg(0);
      }
      el.innerHTML = html;
    });
  }

  /* ---------- accordions ---------- */
  function setupAccordion(root) {
    root.querySelectorAll(".accordion .acc-item").forEach(function (item) {
      var head = item.querySelector(".acc-head");
      var body = item.querySelector(".acc-body");
      if (!head || !body) return;
      // a11y: koppla knapp ↔ panel och spegla öppet/stängt
      if (!body.id) body.id = "smile-acc-" + Math.random().toString(36).slice(2, 8);
      head.setAttribute("aria-controls", body.id);
      head.setAttribute("aria-expanded", item.classList.contains("open") ? "true" : "false");
      head.addEventListener("click", function () {
        if (item.classList.contains("open")) {
          body.style.maxHeight = body.scrollHeight + "px";
          requestAnimationFrame(function () { body.style.maxHeight = "0px"; });
          item.classList.remove("open");
          head.setAttribute("aria-expanded", "false");
        } else {
          item.classList.add("open");
          head.setAttribute("aria-expanded", "true");
          body.style.maxHeight = body.scrollHeight + "px";
          body.addEventListener("transitionend", function te() {
            if (item.classList.contains("open")) body.style.maxHeight = "none";
            body.removeEventListener("transitionend", te);
          });
        }
      });
    });
  }

  /* ---------- buy block ---------- */
  function setupBuy(root) {
    var packs = Array.prototype.slice.call(root.querySelectorAll(".pack"));
    if (!packs.length) return;

    var atc = root.querySelector(".smile-atc");
    var atcNow = root.querySelector(".smile-atc-now");
    var atcWas = root.querySelector(".smile-atc-was");

    function syncAtcPrice() {
      var sel = root.querySelector(".pack.is-active") || packs[0];
      if (!sel) return;
      var now = sel.querySelector(".pk-price .now");
      var was = sel.querySelector(".pk-price .was");
      if (atcNow && now) atcNow.textContent = now.textContent.trim();
      if (atcWas) {
        if (was && was.textContent.trim()) {
          atcWas.textContent = was.textContent.trim();
          atcWas.style.display = "";
        } else {
          atcWas.style.display = "none";
        }
      }
    }

    function selectPack(pack, doFocus) {
      packs.forEach(function (p) {
        var on = p === pack;
        p.classList.toggle("is-active", on);
        p.setAttribute("aria-checked", on ? "true" : "false");
        p.setAttribute("tabindex", on ? "0" : "-1");
      });
      // Paketkort (SMILE Max): ett erbjudande utfällt i taget. Valt paket utan rutor (100 g) →
      // det förvalda paketet hålls utfällt.
      var foldEl = root.querySelector(".packs[data-fold]");
      if (foldEl) {
        var open = pack.querySelector(".pk-gwps") ? pack : root.querySelector('.pack[data-pack="' + foldEl.getAttribute("data-default-pack") + '"]');
        packs.forEach(function (p) {
          if (!p.querySelector(".pk-gwps")) return;
          if (p === open) p.removeAttribute("data-fold-closed"); else p.setAttribute("data-fold-closed", "");
        });
      }
      syncAtcPrice();
      if (doFocus) pack.focus();
    }

    packs.forEach(function (pack, i) {
      pack.addEventListener("click", function () { selectPack(pack, false); });
      pack.addEventListener("keydown", function (e) {
        if (e.key === " " || e.key === "Enter") { e.preventDefault(); selectPack(pack, false); return; }
        if (e.key === "ArrowDown" || e.key === "ArrowRight") { e.preventDefault(); selectPack(packs[(i + 1) % packs.length], true); }
        if (e.key === "ArrowUp" || e.key === "ArrowLeft") { e.preventDefault(); selectPack(packs[(i - 1 + packs.length) % packs.length], true); }
      });
    });

    // Init utan att flytta fokus (annars hoppar sidan vid laddning)
    selectPack(root.querySelector(".pack.is-active") || packs[0], false);

    if (atc) {
      var defaultHtml = atc.innerHTML;
      atc.addEventListener("click", async function (e) {
        e.preventDefault();
        var sel = root.querySelector(".pack.is-active");
        if (!sel) return;

        var variantId = parseInt(sel.getAttribute("data-variant-id"), 10);
        var qty = parseInt(sel.getAttribute("data-quantity"), 10) || 1;

        // Ingen variant inställd ännu → fall tillbaka till ev. produktlänk
        if (!variantId || isNaN(variantId)) {
          var fallback = atc.getAttribute("data-fallback-url");
          if (fallback) { window.location.href = fallback; return; }
          atc.textContent = "Lägg till variant-ID i Customizern";
          setTimeout(function () { atc.innerHTML = defaultHtml; }, 2500);
          return;
        }

        atc.style.pointerEvents = "none";
        atc.textContent = atc.getAttribute("data-label-adding") || "Lägger till…";

        // Gratisgåva (GWP): valt paket kan ha en chip med data-gwp-variant-id —
        // gåvan läggs som egen rad med _gwp-propertyn så att gwp-motorn i
        // SVD Functions gör raden gratis (samma mönster som PDP:ns bundle-JS).
        var items = [{ id: variantId, quantity: qty }];
        Array.prototype.forEach.call(sel.querySelectorAll("[data-gwp-variant-id]"), function (el) {
          var gwpId = parseInt(el.getAttribute("data-gwp-variant-id"), 10);
          if (gwpId > 0) items.push({ id: gwpId, quantity: 1, properties: { "_gwp": "true" } });
        });

        try {
          var res = await fetch(((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/") + "cart/add.js", {
            method: "POST",
            headers: { "Content-Type": "application/json", "Accept": "application/json" },
            body: JSON.stringify({ items: items })
          });
          var data = await res.json();
          if (!res.ok) throw new Error(data.description || "Kunde inte lägga till");

          // Trigga temats cart drawer (Vision 2024 / app.js)
          if (typeof dispatchCustomEvent === "function") {
            dispatchCustomEvent("cart:item-added", { product: data.items ? data.items[0] : data });
            dispatchCustomEvent("cart:refresh");
            dispatchCustomEvent("cart-drawer:open");
          } else {
            window.location.href = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/") + "cart";
            return;
          }

          atc.textContent = atc.getAttribute("data-label-added") || "Tillagd ✓";
          setTimeout(function () { atc.innerHTML = defaultHtml; atc.style.pointerEvents = ""; }, 1600);
        } catch (err) {
          console.error("[svd-smile] Cart error:", err);
          atc.textContent = atc.getAttribute("data-label-error") || "Fel – försök igen";
          setTimeout(function () { atc.innerHTML = defaultHtml; atc.style.pointerEvents = ""; }, 2500);
        }
      });
    }
  }

  /* ---------- sticky header + mobile bar ---------- */
  function setupSticky(root) {
    var bar = root.querySelector(".sticky-bar");
    var head = root.querySelector(".sticky-head");
    var hero = root.querySelector(".hero");
    if (!hero || (!bar && !head)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var show = !en.isIntersecting;
        if (bar) bar.classList.toggle("show", show);
        if (head) head.classList.toggle("show", show);
      });
    }, { rootMargin: "-60px 0px 0px 0px" });
    io.observe(hero);
  }

  function init() {
    document.querySelectorAll(".smile-lp").forEach(function (root) {
      if (root.dataset.smileReady === "1") return;
      root.dataset.smileReady = "1";
      renderStars(root);
      setupAccordion(root);
      setupBuy(root);
      setupSticky(root);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
  // Shopify section re-render i Customizern
  document.addEventListener("shopify:section:load", init);
})();
